/* Phase 2.1: 分頁強調色（僅套用於該分頁 Banner／推薦標籤／分類標籤，不影響全站共用元件）
   Phase 2.7: 四個分頁統一改為藍色系（--jo-primary #4e8bca），不再依分頁差異化配色，只有 bannerImage 情境插畫本身保留各自角色 */
/* Phase 2.6: bannerImage 為桌面版整張情境插畫 banner（取自 banner2.png 裁切），取代舊版右下角小吉祥物貼紙 */

const UNIFIED_BLUE = {
  accent: '#4e8bca',
  accentLight: '#6a9fd3',
  accentPale: '#9cc2e6',
  gradient: 'linear-gradient(135deg, #4e8bca 0%, #6a9fd3 60%, #9cc2e6 100%)',
  tagBg: '#eef4f9',
  tagText: '#376ba1',
};

export const SECTION_THEME = {
  home: { ...UNIFIED_BLUE, bannerImage: '/banners/home-banner-v2.png', bannerBase: '#eaf2f8' },
  sports: { ...UNIFIED_BLUE, bannerImage: '/banners/sports-banner-v2.png', bannerBase: '#eaf2f8' },
  events: { ...UNIFIED_BLUE, bannerImage: '/banners/events-banner-v3.png', bannerBase: '#eaf2f8' },
  travel: { ...UNIFIED_BLUE, bannerImage: '/banners/travel-banner.png', bannerBase: '#eaf2f8' },
};
